import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  grid: {
    maxWidth: 900,
    margin: '0 auto',
  },
  card: {
    height: '100%',
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: theme.shape.borderRadius,
    boxShadow: 'none',
    backgroundColor: theme.palette.background.paper,
    transition: theme.transitions.create(['border-color', 'box-shadow'], {
      duration: theme.transitions.duration.shortest,
    }),
    '&:hover': {
      borderColor: theme.palette.primary.main,
      boxShadow: theme.shadows[2],
    },
  },
  cardAction: {
    height: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    padding: theme.spacing(3),
    textDecoration: 'none',
  },
  icon: {
    width: 52,
    height: 52,
    minWidth: 52,
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.light,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: theme.spacing(2.5),
    '& svg': {
      fontSize: '1.7rem',
    },
  },
  cardContent: {
    padding: 0,
    '&:last-child': {
      paddingBottom: 0,
    },
  },
  title: {
    fontSize: '1.15rem',
    lineHeight: 1.3,
    fontWeight: 600,
    marginBottom: theme.spacing(0.75),
  },
  description: {
    lineHeight: 1.5,
  },
}));